'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function median(nums) {
    if (nums.length === 0) {
        return NaN;
    }
    var sorted = nums.slice().sort(function(a, b) {
        return a - b;
    });
    var middleIndex = Math.floor(sorted.length / 2);
    if (sorted.length % 2 === 0) {
        return (sorted[middleIndex - 1] + sorted[middleIndex]) / 2;
    } else {
        return sorted[middleIndex];
    }
}
exports.median = median;
